@if (!hide()) {
  <div class="viewport-content">
    @if (!title()?.hide) {
      <h2 class="title">
        @if (title()?.title1 !== '') {
          <span class="title-light">
            {{ title()?.title1 }}
          </span>
        }
        @if (title()?.title2 !== '') {
          <span class="title-semibold">
            {{ title()?.title2 }}
          </span>
        }
      </h2>
    }

    <div #sliderRef class="keen-slider">
      @for (card of cards(); track $index) {
        <div
          class="keen-slider__slide number-slide"
          [ngClass]="{ 'slide-visible': isVisibleSlide($index) }"
          [attr.aria-hidden]="!isVisibleSlide($index)"
        >
          <app-home-top-carousel-item [card]="card" [isVisible]="isVisibleSlide($index)" />
        </div>
      }
      @if (slider && slider.track && slider.track.details && showArrows()) {
        <div class="arrow arrow--left">
          <img
            alt="Left"
            tabindex="0"
            height="65"
            width="65"
            role="button"
            aria-label="Previous slide"
            [loaderParams]="{ builder: true }"
            [ngSrc]="
              'https://cdn.builder.io/api/v1/image/assets%2Fb1fc51f68c594d1a8feb8be8be23fbc6%2Fca42efd9624f4a6f836554fcae39c7b2'
            "
            (keyup)="slider.prev()"
            (click)="slider.prev()"
          />
        </div>
        <div class="arrow arrow--right">
          <img
            alt="Right"
            tabindex="0"
            height="65"
            width="65"
            role="button"
            aria-label="Next slide"
            [loaderParams]="{ builder: true }"
            [ngSrc]="
              'https://cdn.builder.io/api/v1/image/assets%2Fb1fc51f68c594d1a8feb8be8be23fbc6%2Ffe77090294804d33870aa11728148299'
            "
            (keyup)="slider.next()"
            (click)="slider.next()"
          />
        </div>
      }
    </div>
    @if (showDots()) {
      <div class="dots">
        @for (slide of dotHelper; track $index) {
          <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
          <button type="button" [class]="'dot ' + ($index === currentSlide() ? 'active' : '')" (click)="slider.moveToIdx($index)">
            <span class="sr-only">Slider step {{ $index }}</span>
          </button>
        }
      </div>
    }
  </div>
}
